import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { useSettingsContext } from 'src/core/settings/useSettings';
import { getNestedValue } from 'src/core/settings/settings';
import { GRID_ROOT_GROUP_ID } from '@mui/x-data-grid-premium';

export const ToggleExpandedRows = ({ props, tableSettings }) => {
  if (tableSettings.treeData === false) {
    return null;
  }

  const { settings, setSetting } = useSettingsContext();
  const persistedExpanded = getNestedValue(settings, ['TableExpanded', tableSettings?.tableName], false,);

  const api = tableSettings.apiRef?.current;

  // Determine the *actual* current state from the grid
  let anyExpanded = false;
  let hasGroups = false;

  if (api) {
    const rootGroupNode = api.getRowNode(GRID_ROOT_GROUP_ID);
    const groups = rootGroupNode?.children ?? [];

    groups.forEach((groupId: any) => {
      const groupNode = api.getRowNode(groupId);
      if (groupNode && groupNode.type === 'group') {
        hasGroups = true;
        if (groupNode.childrenExpanded) {
          anyExpanded = true;
        }
      }
    });
  }

  // Fallback to persisted setting if we don't see any groups yet
  if (!hasGroups) {
    anyExpanded = !!persistedExpanded;
  }

  const toggleExpandRows = () => {
    const api = tableSettings.apiRef?.current;
    if (!api) return;
    const rootGroupNode = api.getRowNode(GRID_ROOT_GROUP_ID);
    const groups = rootGroupNode?.children ?? [];

    // If any group is expanded -> collapse all, else expand all
    const nextExpanded = anyExpanded ? false : true;
    if (groups.length > 0) {
      groups.forEach((groupId: any) => {
        const groupNode = api.getRowNode(groupId);
        if (groupNode && groupNode.type === 'group') {
          api.setRowChildrenExpansion(groupId, nextExpanded);
        }
      });
    }

    // Persist the global state so initial expansion logic still works
    setSetting(['TableExpanded', tableSettings?.tableName], nextExpanded,);
  };

  const hideMenu = () => {
    tableSettings.apiRef?.current?.hideColumnMenu();
  };

  const toggleExpandText = anyExpanded ? 'Collapse All' : 'Expand All';

  return (
    <MenuItem onClick={(e) => { hideMenu(); toggleExpandRows(); }}>
      <ListItemIcon>{anyExpanded ? (
        <UnfoldLessIcon fontSize="small" />
      ) : (
        <UnfoldMoreIcon fontSize="small" />
      )}</ListItemIcon>
      <ListItemText>{toggleExpandText}</ListItemText>
    </MenuItem>
  );
};
